import { FRAMES_CATALOG } from './framesCatalog';

const outlineSvg = (content) => (
  `<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">${content}</svg>`
);

const solidSvg = (content) => (
  `<svg viewBox="0 0 100 100" fill="currentColor">${content}</svg>`
);

const frameSvg = (outer, inner) => (
  `<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="5" stroke-linejoin="round">${outer}${inner}</svg>`
);

const iconSvg = (content) => (
  `<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round" stroke-linejoin="round">${content}</svg>`
);

const gradientPreview = (content) => (
  `<svg viewBox="0 0 100 100" fill="none">${content}</svg>`
);

export const ELEMENT_CATEGORIES = [
  { id: 'shapes', title: 'Shapes', iconKey: 'shapes' },
  { id: 'graphics', title: 'Graphics', iconKey: 'graphics' },
  { id: 'photos', title: 'Photos', iconKey: 'photos' },
  { id: 'videos', title: 'Videos', iconKey: 'videos', disabled: true },
  { id: '3d', title: '3D', iconKey: '3d', disabled: true },
  { id: 'forms', title: 'Forms', iconKey: 'forms' },
  { id: 'animations', title: 'Animations', iconKey: 'animations', disabled: true },
  { id: 'audio', title: 'Audio', iconKey: 'audio', disabled: true },
  { id: 'sheets', title: 'Sheets', iconKey: 'sheets', disabled: true },
  { id: 'tables', title: 'Tables', iconKey: 'tables' },
  { id: 'charts', title: 'Charts', iconKey: 'charts' },
  { id: 'frames', title: 'Frames', iconKey: 'frames' },
  { id: 'grids', title: 'Grids', iconKey: 'grids' },
  { id: 'mockups', title: 'Mockups', iconKey: 'mockups', disabled: true },
];

const shapeItems = [
  {
    catalogId: 'shape-rectangle',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Rectangle',
    tags: ['shape', 'rectangle', 'box'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="64" height="52" rx="4" />') },
    payload: { type: 'shape', shapeKind: 'rect', defaultRadius: 6 },
  },
  {
    catalogId: 'shape-rounded-rectangle',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Rounded Rectangle',
    tags: ['shape', 'rounded', 'card'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="64" height="52" rx="16" />') },
    payload: { type: 'shape', shapeKind: 'rounded', defaultRadius: 18 },
  },
  {
    catalogId: 'shape-pill',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Pill',
    tags: ['shape', 'pill', 'button'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="16" y="36" width="68" height="28" rx="14" />') },
    payload: { type: 'shape', shapeKind: 'pill', defaultRadius: 32 },
  },
  {
    catalogId: 'shape-circle',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Circle',
    tags: ['shape', 'circle'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<circle cx="50" cy="50" r="28" />') },
    payload: { type: 'shape', shapeKind: 'circle' },
  },
  {
    catalogId: 'shape-triangle',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Triangle',
    tags: ['shape', 'triangle'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 18L82 78H18L50 18Z" />') },
    payload: { type: 'shape', shapeKind: 'triangle' },
  },
  {
    catalogId: 'shape-diamond',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Diamond',
    tags: ['shape', 'diamond'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 14L86 50L50 86L14 50L50 14Z" />') },
    payload: { type: 'shape', shapeKind: 'diamond' },
  },
  {
    catalogId: 'shape-star',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Star',
    tags: ['shape', 'star'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 16L61 40H86L66 56L74 82L50 66L26 82L34 56L14 40H39L50 16Z" />') },
    payload: { type: 'shape', shapeKind: 'star' },
  },
  {
    catalogId: 'shape-speech',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Speech Bubble',
    tags: ['shape', 'speech', 'bubble'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M22 26H78V62H44L32 78V62H22V26Z" />') },
    payload: { type: 'shape', shapeKind: 'speech' },
  },
  {
    catalogId: 'shape-badge',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Badge',
    tags: ['shape', 'badge', 'seal'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 14L64 22L80 20L76 36L88 46L72 52L68 68L50 60L32 68L28 52L12 46L24 36L20 20L36 22L50 14Z" />') },
    payload: { type: 'shape', shapeKind: 'badge' },
  },
  {
    catalogId: 'shape-blob',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Blob',
    tags: ['shape', 'blob', 'organic'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M62 18C72 26 78 38 76 52C74 66 64 78 50 80C36 82 22 74 18 60C14 46 20 30 32 22C44 14 54 10 62 18Z" />') },
    payload: { type: 'shape', shapeKind: 'blob' },
  },
  {
    catalogId: 'shape-oval',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Oval',
    tags: ['shape', 'oval', 'ellipse'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<ellipse cx="50" cy="50" rx="34" ry="22" />') },
    payload: { type: 'shape', shapeKind: 'circle', width: 340, height: 220 },
  },
  {
    catalogId: 'shape-right-triangle',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Right Triangle',
    tags: ['shape', 'triangle', 'right'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M18 78L18 22L82 78Z" />') },
    payload: { type: 'shape', shapeKind: 'triangle' },
  },
  {
    catalogId: 'shape-pentagon',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Pentagon',
    tags: ['shape', 'pentagon'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 16L84 40L72 78H28L16 40Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-hexagon',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Hexagon',
    tags: ['shape', 'hexagon'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 14L82 32V68L50 86L18 68V32Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-octagon',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Octagon',
    tags: ['shape', 'octagon', 'stop'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M34 16H66L86 34V66L66 84H34L14 66V34Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-star6',
    category: 'shapes',
    subcategory: 'decor',
    title: '6-Point Star',
    tags: ['shape', 'star', 'six'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 14L62 38L88 38L68 56L76 82L50 66L24 82L32 56L12 38L38 38Z" />') },
    payload: { type: 'shape', shapeKind: 'star' },
  },
  {
    catalogId: 'shape-heart',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Heart',
    tags: ['shape', 'heart', 'love'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 82S16 60 16 36a18 18 0 0134-8 18 18 0 0134 8C84 60 50 82 50 82Z" />') },
    payload: { type: 'shape', shapeKind: 'blob' },
  },
  {
    catalogId: 'shape-cloud',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Cloud',
    tags: ['shape', 'cloud'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M28 68a16 16 0 010-32 20 20 0 0138-4 14 14 0 0116 16 12 12 0 01-2 24Z" />') },
    payload: { type: 'shape', shapeKind: 'blob' },
  },
  {
    catalogId: 'shape-crescent',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Crescent',
    tags: ['shape', 'crescent', 'moon'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M60 18A30 30 0 1060 82 24 24 0 0060 18Z" />') },
    payload: { type: 'shape', shapeKind: 'blob' },
  },
  {
    catalogId: 'shape-plus',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Plus',
    tags: ['shape', 'plus', 'add'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M40 18V40H18V60H40V82H60V60H82V40H60V18Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-cross',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Cross',
    tags: ['shape', 'cross', 'x'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M26 18L50 42L74 18L82 26L58 50L82 74L74 82L50 58L26 82L18 74L42 50L18 26Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-parallelogram',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Parallelogram',
    tags: ['shape', 'parallelogram'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M30 24H82L70 76H18Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-trapezoid',
    category: 'shapes',
    subcategory: 'basic',
    title: 'Trapezoid',
    tags: ['shape', 'trapezoid'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M30 24H70L84 76H16Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-house',
    category: 'shapes',
    subcategory: 'decor',
    title: 'House',
    tags: ['shape', 'house', 'home', 'real-estate'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M50 16L86 46V82H14V46Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
  {
    catalogId: 'shape-arrow-right',
    category: 'shapes',
    subcategory: 'decor',
    title: 'Arrow Shape',
    tags: ['shape', 'arrow', 'chevron'],
    kind: 'shape',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M14 30H60L86 50L60 70H14L40 50Z" />') },
    payload: { type: 'shape', shapeKind: 'rect' },
  },
];

const graphicItems = [
  { id: 'graphic-phone', title: 'Phone', tags: ['phone', 'call', 'contact'], svg: iconSvg('<rect x="32" y="18" width="36" height="64" rx="8" /><circle cx="50" cy="70" r="3" />') },
  { id: 'graphic-whatsapp', title: 'WhatsApp', tags: ['whatsapp', 'chat'], svg: iconSvg('<circle cx="50" cy="50" r="26" /><path d="M42 38l8 8-4 6 8 8" />') },
  { id: 'graphic-location', title: 'Location Pin', tags: ['location', 'pin', 'map'], svg: iconSvg('<path d="M50 16C38 16 30 26 30 38c0 18 20 38 20 38s20-20 20-38C70 26 62 16 50 16Z" /><circle cx="50" cy="38" r="6" />') },
  { id: 'graphic-home', title: 'Home', tags: ['home', 'house'], svg: iconSvg('<path d="M20 52L50 24L80 52" /><path d="M30 48V76H70V48" />') },
  { id: 'graphic-building', title: 'Building', tags: ['building', 'office'], svg: iconSvg('<rect x="26" y="20" width="48" height="60" rx="4" /><path d="M36 30H46M54 30H64M36 42H46M54 42H64M36 54H46M54 54H64" />') },
  { id: 'graphic-key', title: 'Key', tags: ['key', 'access'], svg: iconSvg('<circle cx="40" cy="44" r="12" /><path d="M52 44H82M70 44V54M62 44V54" />') },
  { id: 'graphic-rupee', title: 'Rupee', tags: ['rupee', 'price'], svg: iconSvg('<path d="M32 28H66M32 38H66M44 38C44 52 32 60 32 60H68" />') },
  { id: 'graphic-calendar', title: 'Calendar', tags: ['calendar', 'date'], svg: iconSvg('<rect x="24" y="30" width="52" height="46" rx="6" /><path d="M24 40H76M38 22V30M62 22V30" />') },
  { id: 'graphic-check', title: 'Check', tags: ['check', 'verified'], svg: iconSvg('<path d="M26 52L42 68L76 32" />') },
  { id: 'graphic-map', title: 'Map', tags: ['map', 'route'], svg: iconSvg('<path d="M26 28L44 22L58 28L74 22V72L58 78L44 72L26 78V28Z" /><path d="M44 22V72M58 28V78" />') },
  { id: 'graphic-camera', title: 'Camera', tags: ['camera', 'photo'], svg: iconSvg('<rect x="22" y="32" width="56" height="40" rx="8" /><circle cx="50" cy="52" r="12" /><path d="M34 32L40 24H60L66 32" />') },
  { id: 'graphic-bed', title: 'Bed', tags: ['bed', 'bedroom'], svg: iconSvg('<path d="M20 56H80V70H20Z" /><path d="M24 56V40H52V56M52 56V44H76V56" />') },
  { id: 'graphic-bath', title: 'Bath', tags: ['bath', 'bathroom'], svg: iconSvg('<path d="M24 54H76V64H24Z" /><path d="M36 54V36H56" /><path d="M28 64L22 74M72 64L78 74" />') },
  { id: 'graphic-sqft', title: 'Sqft', tags: ['sqft', 'area'], svg: iconSvg('<rect x="24" y="24" width="52" height="52" rx="4" /><path d="M32 32H48M32 44H56M32 56H60" />') },
  { id: 'graphic-handshake', title: 'Handshake', tags: ['handshake', 'deal'], svg: iconSvg('<path d="M28 46L46 28L58 40L72 26L84 38L62 60L40 38L28 50Z" />') },
  { id: 'graphic-star', title: 'Star', tags: ['star', 'rating'], svg: iconSvg('<path d="M50 20L60 44H86L64 58L72 82L50 66L28 82L36 58L14 44H40L50 20Z" />') },
  { id: 'graphic-shield', title: 'Shield', tags: ['shield', 'secure'], svg: iconSvg('<path d="M50 18L76 26V50C76 66 64 78 50 82C36 78 24 66 24 50V26L50 18Z" />') },
  { id: 'graphic-mail', title: 'Email', tags: ['mail', 'email'], svg: iconSvg('<rect x="22" y="30" width="56" height="40" rx="6" /><path d="M22 32L50 52L78 32" />') },
  { id: 'graphic-globe', title: 'Globe', tags: ['globe', 'website'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M22 50H78M50 22C60 34 60 66 50 78M50 22C40 34 40 66 50 78" />') },
  { id: 'graphic-office', title: 'Office', tags: ['office', 'workspace'], svg: iconSvg('<rect x="24" y="28" width="52" height="52" rx="4" /><path d="M24 52H76M38 28V80M62 28V80" />') },
  { id: 'graphic-chart', title: 'Chart', tags: ['chart', 'analytics'], svg: iconSvg('<path d="M24 74H76" /><path d="M32 68V44M50 68V36M68 68V52" />') },
  { id: 'graphic-arrow-right', title: 'Arrow Right', tags: ['arrow', 'direction'], svg: iconSvg('<path d="M24 50H76M60 34L76 50L60 66" />') },
  { id: 'graphic-arrow-left', title: 'Arrow Left', tags: ['arrow', 'direction'], svg: iconSvg('<path d="M76 50H24M40 34L24 50L40 66" />') },
  { id: 'graphic-arrow-up', title: 'Arrow Up', tags: ['arrow', 'direction'], svg: iconSvg('<path d="M50 76V24M34 40L50 24L66 40" />') },
  { id: 'graphic-arrow-down', title: 'Arrow Down', tags: ['arrow', 'direction'], svg: iconSvg('<path d="M50 24V76M34 60L50 76L66 60" />') },
  { id: 'graphic-map-pin', title: 'Map Pin', tags: ['pin', 'map'], svg: iconSvg('<path d="M50 18C38 18 30 28 30 40c0 18 20 38 20 38s20-20 20-38C70 28 62 18 50 18Z" /><circle cx="50" cy="40" r="6" />') },
  { id: 'graphic-heart', title: 'Heart', tags: ['heart', 'favorite'], svg: iconSvg('<path d="M50 78S22 60 22 38a14 14 0 0124-10l4 4 4-4a14 14 0 0124 10C78 60 50 78 50 78Z" />') },
  { id: 'graphic-wallet', title: 'Wallet', tags: ['wallet', 'payment'], svg: iconSvg('<rect x="22" y="34" width="56" height="36" rx="6" /><path d="M56 44H78V60H56Z" />') },
  { id: 'graphic-clipboard', title: 'Clipboard', tags: ['clipboard', 'checklist'], svg: iconSvg('<rect x="30" y="22" width="40" height="56" rx="6" /><path d="M40 22H60V28H40Z" /><path d="M38 40H62M38 52H62M38 64H54" />') },
  { id: 'graphic-tick-circle', title: 'Tick Circle', tags: ['tick', 'approved'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M36 52L46 62L68 38" />') },
  { id: 'graphic-phone-call', title: 'Phone Call', tags: ['phone', 'call'], svg: iconSvg('<path d="M34 24C40 40 60 60 76 66" /><path d="M30 28L38 20L48 30L40 38" /><path d="M70 64L78 56L70 48L62 56" />') },
  { id: 'graphic-ruler', title: 'Ruler', tags: ['measure', 'ruler'], svg: iconSvg('<rect x="24" y="40" width="52" height="20" rx="4" /><path d="M32 40V50M42 40V48M52 40V50M62 40V48M72 40V50" />') },
  { id: 'graphic-bell', title: 'Notification', tags: ['bell', 'alert'], svg: iconSvg('<path d="M50 20C40 20 34 28 34 38V56L26 64H74L66 56V38C66 28 60 20 50 20Z" /><path d="M44 68a6 6 0 0012 0" />') },
  { id: 'graphic-clock', title: 'Clock', tags: ['clock', 'time'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M50 34V52L64 58" />') },
  { id: 'graphic-tag', title: 'Tag', tags: ['tag', 'label'], svg: iconSvg('<path d="M22 44L50 20L78 48L50 76L22 48Z" /><circle cx="50" cy="36" r="4" />') },
  { id: 'graphic-briefcase', title: 'Briefcase', tags: ['briefcase', 'business'], svg: iconSvg('<rect x="24" y="36" width="52" height="34" rx="6" /><path d="M40 36V28H60V36" />') },
  { id: 'graphic-checklist', title: 'Checklist', tags: ['list', 'checklist'], svg: iconSvg('<path d="M30 34H70M30 50H70M30 66H56" /><path d="M22 34L26 38L34 30M22 50L26 54L34 46" />') },
  { id: 'graphic-share', title: 'Share', tags: ['share'], svg: iconSvg('<circle cx="30" cy="50" r="8" /><circle cx="70" cy="30" r="8" /><circle cx="70" cy="70" r="8" /><path d="M38 46L62 34M38 54L62 66" />') },
  { id: 'graphic-user', title: 'User', tags: ['user', 'agent'], svg: iconSvg('<circle cx="50" cy="38" r="12" /><path d="M26 74C30 60 70 60 74 74" />') },
  { id: 'graphic-users', title: 'Users', tags: ['users', 'team'], svg: iconSvg('<circle cx="40" cy="42" r="10" /><circle cx="64" cy="38" r="8" /><path d="M22 74C26 62 54 62 58 74M52 74C54 64 72 62 78 72" />') },
  { id: 'graphic-document', title: 'Document', tags: ['document', 'file'], svg: iconSvg('<path d="M30 20H62L74 32V80H30Z" /><path d="M62 20V32H74" /><path d="M38 46H62M38 58H62M38 70H54" />') },
  { id: 'graphic-rupee-circle', title: 'Rupee Circle', tags: ['rupee', 'currency'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M40 38H62M40 46H62M48 46C48 60 40 64 40 64H62" />') },
  { id: 'graphic-location-target', title: 'Location Target', tags: ['location', 'target'], svg: iconSvg('<circle cx="50" cy="50" r="22" /><circle cx="50" cy="50" r="6" /><path d="M50 20V30M50 70V80M20 50H30M70 50H80" />') },
  { id: 'graphic-keychain', title: 'Keychain', tags: ['keychain', 'keys'], svg: iconSvg('<circle cx="40" cy="46" r="10" /><path d="M50 46H74M66 46V58M58 46V58" />') },
  { id: 'graphic-rupee-tag', title: 'Price Tag', tags: ['price', 'tag'], svg: iconSvg('<path d="M22 40L48 20L78 50L50 78L22 50Z" /><path d="M50 34H66" />') },
  // --- Amenities ---
  { id: 'graphic-pool', title: 'Swimming Pool', tags: ['pool', 'swimming', 'amenity'], svg: iconSvg('<path d="M20 60C28 52 36 68 44 60C52 52 60 68 68 60C76 52 84 60 84 60" /><path d="M20 72C28 64 36 80 44 72C52 64 60 80 68 72C76 64 84 72 84 72" /><path d="M36 40V56M64 40V56M30 40H70" />') },
  { id: 'graphic-gym', title: 'Gym', tags: ['gym', 'fitness', 'amenity'], svg: iconSvg('<path d="M22 50H78M22 38V62M78 38V62M30 42V58M70 42V58" />') },
  { id: 'graphic-parking', title: 'Parking', tags: ['parking', 'car', 'amenity'], svg: iconSvg('<rect x="24" y="20" width="52" height="60" rx="8" /><path d="M40 48V68M40 48H56A10 10 0 000 56 10 0 0056 28H40V48Z" />') },
  { id: 'graphic-garden', title: 'Garden', tags: ['garden', 'park', 'amenity'], svg: iconSvg('<path d="M50 82V50" /><path d="M50 50C50 30 30 24 30 24S50 30 50 50Z" /><path d="M50 50C50 30 70 24 70 24S50 30 50 50Z" /><path d="M20 82H80" />') },
  { id: 'graphic-elevator', title: 'Elevator', tags: ['elevator', 'lift', 'amenity'], svg: iconSvg('<rect x="26" y="18" width="48" height="64" rx="6" /><path d="M50 18V82M40 34L50 24L60 34M40 66L50 76L60 66" />') },
  { id: 'graphic-cctv', title: 'CCTV', tags: ['cctv', 'security', 'amenity'], svg: iconSvg('<path d="M24 40H56V68H24Z" /><path d="M56 48L78 36V72L56 60" /><path d="M24 68L24 76H32" />') },
  { id: 'graphic-fire', title: 'Fire Safety', tags: ['fire', 'safety', 'amenity'], svg: iconSvg('<path d="M50 18C50 18 66 34 66 54C66 66 58 78 50 78C42 78 34 66 34 54C34 34 50 18 50 18Z" /><path d="M50 78C46 78 42 72 42 66C42 58 50 50 50 50S58 58 58 66C58 72 54 78 50 78Z" />') },
  { id: 'graphic-solar', title: 'Solar Panel', tags: ['solar', 'green', 'amenity'], svg: iconSvg('<path d="M22 60L34 28H66L78 60Z" /><path d="M28 48H72M34 36H66M50 28V60" /><circle cx="50" cy="16" r="6" /><path d="M50 10V4M36 16H30M64 16H70M38 8L34 4M62 8L66 4" />') },
  { id: 'graphic-wifi', title: 'WiFi', tags: ['wifi', 'internet', 'amenity'], svg: iconSvg('<circle cx="50" cy="72" r="4" /><path d="M36 62C42 56 58 56 64 62" /><path d="M26 52C36 42 64 42 74 52" /><path d="M16 42C30 28 70 28 84 42" />') },
  { id: 'graphic-ac', title: 'AC', tags: ['ac', 'cooling', 'amenity'], svg: iconSvg('<rect x="22" y="28" width="56" height="30" rx="6" /><path d="M30 58V70M50 58V74M70 58V70M36 64C40 70 44 66 48 72M56 64C60 70 64 66 68 72" />') },
  { id: 'graphic-power', title: 'Power Backup', tags: ['power', 'backup', 'amenity'], svg: iconSvg('<path d="M56 18L38 52H50L44 82L66 46H52L56 18Z" />') },
  { id: 'graphic-water', title: 'Water Supply', tags: ['water', 'supply', 'amenity'], svg: iconSvg('<path d="M50 18C50 18 74 42 74 58A24 24 0 0126 58C26 42 50 18 50 18Z" />') },
  { id: 'graphic-intercom', title: 'Intercom', tags: ['intercom', 'security', 'amenity'], svg: iconSvg('<rect x="30" y="18" width="40" height="64" rx="8" /><circle cx="50" cy="40" r="10" /><path d="M42 60H58M42 68H58" />') },
  // --- Social Media ---
  { id: 'graphic-instagram', title: 'Instagram', tags: ['instagram', 'social'], svg: iconSvg('<rect x="22" y="22" width="56" height="56" rx="14" /><circle cx="50" cy="50" r="14" /><circle cx="64" cy="36" r="3" fill="currentColor" stroke="none" />') },
  { id: 'graphic-facebook', title: 'Facebook', tags: ['facebook', 'social'], svg: iconSvg('<path d="M68 18H58C50 18 44 24 44 32V42H34V54H44V82H56V54H66L68 42H56V34C56 30 58 28 62 28H68V18Z" />') },
  { id: 'graphic-linkedin', title: 'LinkedIn', tags: ['linkedin', 'social'], svg: iconSvg('<rect x="22" y="44" width="14" height="36" rx="2" /><circle cx="29" cy="30" r="8" /><path d="M48 44V80H62V60C62 54 68 52 70 56V80H84V54C84 42 72 40 62 48V44H48Z" />') },
  { id: 'graphic-youtube', title: 'YouTube', tags: ['youtube', 'social'], svg: iconSvg('<rect x="18" y="26" width="64" height="48" rx="10" /><path d="M44 38V62L64 50Z" fill="currentColor" stroke="none" />') },
  { id: 'graphic-twitter', title: 'Twitter / X', tags: ['twitter', 'x', 'social'], svg: iconSvg('<path d="M22 22L46 52L22 78M78 22L54 52L78 78" /><path d="M22 22H42L78 78H58Z" />') },
  { id: 'graphic-pinterest', title: 'Pinterest', tags: ['pinterest', 'social'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M44 68C46 58 50 44 50 44C48 40 50 34 54 34C58 34 58 40 56 46C54 52 50 58 52 62C54 66 60 64 64 56" />') },
  { id: 'graphic-telegram', title: 'Telegram', tags: ['telegram', 'social'], svg: iconSvg('<path d="M20 50L78 24L64 78L46 58L78 24" /><path d="M46 58L50 74L56 62" />') },
  { id: 'graphic-google', title: 'Google', tags: ['google', 'social'], svg: iconSvg('<path d="M78 50H52M50 22A28 28 0 1072 62" />') },
  // --- Status Badges ---
  { id: 'graphic-for-sale', title: 'For Sale', tags: ['sale', 'status', 'sign'], svg: iconSvg('<rect x="18" y="28" width="64" height="44" rx="6" /><path d="M34 44H44M56 44H66M34 56H66" />') },
  { id: 'graphic-for-rent', title: 'For Rent', tags: ['rent', 'status', 'sign'], svg: iconSvg('<rect x="18" y="28" width="64" height="44" rx="6" /><path d="M30 50H70" /><circle cx="50" cy="42" r="4" fill="currentColor" stroke="none" />') },
  { id: 'graphic-sold', title: 'Sold', tags: ['sold', 'status'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M32 50H68" /><path d="M50 32V68" transform="rotate(45 50 50)" />') },
  { id: 'graphic-new-launch', title: 'New Launch', tags: ['new', 'launch', 'status'], svg: iconSvg('<path d="M50 14L64 22L80 20L76 36L88 46L72 52L68 68L50 60L32 68L28 52L12 46L24 36L20 20L36 22Z" /><circle cx="50" cy="42" r="8" />') },
  { id: 'graphic-under-construction', title: 'Under Construction', tags: ['construction', 'status'], svg: iconSvg('<path d="M20 78H80M28 78V42L50 26L72 42V78" /><path d="M30 50H70M30 62H70" stroke-dasharray="6 4" />') },
  { id: 'graphic-ready-move', title: 'Ready to Move', tags: ['ready', 'move', 'status'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M36 52L46 62L68 38" />') },
  { id: 'graphic-furnished', title: 'Furnished', tags: ['furnished', 'status'], svg: iconSvg('<path d="M24 60H76V72H24Z" /><path d="M30 48H70V60H30Z" /><path d="M24 72V78M76 72V78" />') },
  // --- Nearby Places ---
  { id: 'graphic-school', title: 'School', tags: ['school', 'education', 'nearby'], svg: iconSvg('<path d="M50 22L82 38V54L50 70L18 54V38Z" /><path d="M30 44V62L50 72L70 62V44" /><path d="M82 38V60" />') },
  { id: 'graphic-hospital', title: 'Hospital', tags: ['hospital', 'medical', 'nearby'], svg: iconSvg('<rect x="24" y="24" width="52" height="52" rx="8" /><path d="M42 36V64M36 50H64" />') },
  { id: 'graphic-mall', title: 'Mall', tags: ['mall', 'shopping', 'nearby'], svg: iconSvg('<path d="M20 40H80V78H20Z" /><path d="M26 40V28H74V40" /><path d="M40 78V58H60V78" /><path d="M20 54H80" />') },
  { id: 'graphic-temple', title: 'Temple', tags: ['temple', 'worship', 'nearby'], svg: iconSvg('<path d="M50 18L76 40V78H24V40Z" /><path d="M38 78V58H62V78" /><path d="M50 40V52" /><circle cx="50" cy="14" r="4" />') },
  { id: 'graphic-restaurant', title: 'Restaurant', tags: ['restaurant', 'food', 'nearby'], svg: iconSvg('<path d="M30 20V46C30 52 36 56 42 56V80" /><path d="M56 20V30C56 36 62 40 68 36V20" /><path d="M62 40V80" />') },
  { id: 'graphic-metro', title: 'Metro', tags: ['metro', 'train', 'nearby'], svg: iconSvg('<rect x="26" y="24" width="48" height="42" rx="10" /><path d="M38 66L30 78M62 66L70 78" /><circle cx="38" cy="54" r="4" fill="currentColor" stroke="none" /><circle cx="62" cy="54" r="4" fill="currentColor" stroke="none" /><path d="M36 38H64" />') },
  { id: 'graphic-bus', title: 'Bus Stop', tags: ['bus', 'transport', 'nearby'], svg: iconSvg('<rect x="24" y="28" width="52" height="40" rx="6" /><path d="M24 48H76" /><circle cx="36" cy="62" r="4" /><circle cx="64" cy="62" r="4" /><path d="M32 28V22H68V28" />') },
  { id: 'graphic-airport', title: 'Airport', tags: ['airport', 'flight', 'nearby'], svg: iconSvg('<path d="M50 18V78" /><path d="M20 46L50 34L80 46" /><path d="M34 68L50 62L66 68" />') },
  { id: 'graphic-highway', title: 'Highway', tags: ['highway', 'road', 'nearby'], svg: iconSvg('<path d="M26 80L44 20H56L74 80" /><path d="M50 28V36M50 44V52M50 60V68" stroke-dasharray="8 8" />') },
  // --- Measurement / BHK ---
  { id: 'graphic-bhk1', title: '1 BHK', tags: ['1bhk', 'bhk', 'config'], svg: iconSvg('<rect x="22" y="22" width="56" height="56" rx="6" /><path d="M34 50H46V66H34Z" /><path d="M52 34H66V66H52Z" />') },
  { id: 'graphic-bhk2', title: '2 BHK', tags: ['2bhk', 'bhk', 'config'], svg: iconSvg('<rect x="20" y="22" width="60" height="56" rx="6" /><path d="M30 44H44V66H30Z" /><path d="M50 44H64V66H50Z" /><path d="M30 30H64V40H30Z" />') },
  { id: 'graphic-bhk3', title: '3 BHK', tags: ['3bhk', 'bhk', 'config'], svg: iconSvg('<rect x="18" y="22" width="64" height="56" rx="6" /><path d="M26 44H38V66H26Z" /><path d="M44 44H56V66H44Z" /><path d="M62 44H74V66H62Z" />') },
  { id: 'graphic-floor', title: 'Floor', tags: ['floor', 'level', 'storey'], svg: iconSvg('<rect x="26" y="18" width="48" height="64" rx="4" /><path d="M26 38H74M26 58H74" /><path d="M40 24H52M40 44H52M40 64H52" />') },
  // --- Finance / Legal ---
  { id: 'graphic-emi', title: 'EMI', tags: ['emi', 'loan', 'finance'], svg: iconSvg('<rect x="22" y="30" width="56" height="40" rx="8" /><path d="M34 44H50M34 54H66" /><path d="M58 38V44" /><circle cx="62" cy="54" r="4" fill="currentColor" stroke="none" />') },
  { id: 'graphic-loan', title: 'Loan', tags: ['loan', 'bank', 'finance'], svg: iconSvg('<path d="M22 38H78V74H22Z" /><path d="M50 22L78 38H22Z" /><path d="M34 50V68M50 46V68M66 50V68" /><path d="M22 74H78" />') },
  { id: 'graphic-rera', title: 'RERA', tags: ['rera', 'legal', 'approved'], svg: iconSvg('<path d="M50 18L76 28V50C76 66 64 78 50 82C36 78 24 66 24 50V28Z" /><path d="M36 52L46 62L68 38" />') },
  { id: 'graphic-agreement', title: 'Agreement', tags: ['agreement', 'contract', 'legal'], svg: iconSvg('<path d="M30 20H62L74 32V80H30Z" /><path d="M62 20V32H74" /><path d="M38 44H62M38 54H62M38 64H54" /><path d="M38 36L42 40L48 32" />') },
  // --- Compass / Navigation ---
  { id: 'graphic-compass', title: 'Compass', tags: ['compass', 'direction', 'navigation'], svg: iconSvg('<circle cx="50" cy="50" r="28" /><path d="M40 60L34 34L60 40L66 66Z" /><circle cx="50" cy="50" r="3" fill="currentColor" stroke="none" />') },
  { id: 'graphic-north', title: 'North Arrow', tags: ['north', 'direction'], svg: iconSvg('<path d="M50 18V82" /><path d="M36 34L50 18L64 34" /><path d="M46 46L50 18L54 46Z" fill="currentColor" stroke="none" />') },
  { id: 'graphic-qr', title: 'QR Code', tags: ['qr', 'code', 'scan'], svg: iconSvg('<rect x="22" y="22" width="20" height="20" rx="2" /><rect x="58" y="22" width="20" height="20" rx="2" /><rect x="22" y="58" width="20" height="20" rx="2" /><rect x="28" y="28" width="8" height="8" fill="currentColor" stroke="none" /><rect x="64" y="28" width="8" height="8" fill="currentColor" stroke="none" /><rect x="28" y="64" width="8" height="8" fill="currentColor" stroke="none" /><path d="M58 58H66V66M70 58V78H58M66 70H78V58" />') },
];

const graphicElements = graphicItems.map((item) => ({
  catalogId: item.id,
  category: 'graphics',
  subcategory: 'icons',
  title: item.title,
  tags: ['graphic', ...item.tags],
  kind: 'graphic',
  preview: { type: 'svg', inlineSvg: item.svg },
  payload: { type: 'graphic', svg: item.svg },
}));

const photoEntries = [
  // --- Exteriors ---
  { id: 'photo-ext-1', sub: 'exteriors', title: 'Modern Apartment Building', photoId: '1545324418-cc1a3fa10c00' },
  { id: 'photo-ext-2', sub: 'exteriors', title: 'Luxury Villa Exterior', photoId: '1600596542815-ffad4c1539a9' },
  { id: 'photo-ext-3', sub: 'exteriors', title: 'Townhouse Row', photoId: '1558036117-15d82a90b9b1' },
  { id: 'photo-ext-4', sub: 'exteriors', title: 'Commercial Office Building', photoId: '1486406146926-c627a92ad1ab' },
  { id: 'photo-ext-5', sub: 'exteriors', title: 'Contemporary Home', photoId: '1564013799919-ab600027ffc6' },
  { id: 'photo-ext-6', sub: 'exteriors', title: 'Classic Bungalow', photoId: '1570129477492-45c003edd2be' },
  { id: 'photo-ext-7', sub: 'exteriors', title: 'White Modern House', photoId: '1523217553-7b5e2feed364' },
  { id: 'photo-ext-8', sub: 'exteriors', title: 'Suburban Home', photoId: '1583608205776-bfd35f0d9f83' },
  // --- Interiors ---
  { id: 'photo-int-1', sub: 'interiors', title: 'Modern Living Room', photoId: '1600210492493-0946911123ea' },
  { id: 'photo-int-2', sub: 'interiors', title: 'Designer Bedroom', photoId: '1616594039964-ae9021a400a0' },
  { id: 'photo-int-3', sub: 'interiors', title: 'Luxury Kitchen', photoId: '1556909114-f6e7ad7d3136' },
  { id: 'photo-int-4', sub: 'interiors', title: 'Elegant Bathroom', photoId: '1552321554-5fefe8c9ef14' },
  { id: 'photo-int-5', sub: 'interiors', title: 'Spacious Dining Room', photoId: '1617806118233-18e1de247200' },
  { id: 'photo-int-6', sub: 'interiors', title: 'Home Office Setup', photoId: '1618221195710-dd6b41faaea6' },
  { id: 'photo-int-7', sub: 'interiors', title: 'Open Floor Plan', photoId: '1600607687939-ce8a6c25118c' },
  { id: 'photo-int-8', sub: 'interiors', title: 'Cozy Reading Nook', photoId: '1600585154340-be6161a56a0c' },
  // --- Amenities ---
  { id: 'photo-amen-1', sub: 'amenities', title: 'Swimming Pool', photoId: '1572331165267-854da2b021b1' },
  { id: 'photo-amen-2', sub: 'amenities', title: 'Modern Gym', photoId: '1534438327276-14e5300c3a48' },
  { id: 'photo-amen-3', sub: 'amenities', title: 'Rooftop Garden', photoId: '1558618666-fcd25c85f82e' },
  { id: 'photo-amen-4', sub: 'amenities', title: 'Clubhouse Lounge', photoId: '1600566753086-00f18fb6b3ea' },
  { id: 'photo-amen-5', sub: 'amenities', title: 'Children Playground', photoId: '1575783970733-1aaedde1db74' },
  { id: 'photo-amen-6', sub: 'amenities', title: 'Landscaped Walkway', photoId: '1558904541-efa843a96f01' },
  { id: 'photo-amen-7', sub: 'amenities', title: 'Spa and Wellness', photoId: '1540555700478-4be289fbec6f' },
  { id: 'photo-amen-8', sub: 'amenities', title: 'Indoor Basketball Court', photoId: '1504450758-3c0faf3a9bfc' },
  // --- Aerial / Cityscapes ---
  { id: 'photo-aerial-1', sub: 'aerial', title: 'City Skyline', photoId: '1449824913935-59a10b8d2000' },
  { id: 'photo-aerial-2', sub: 'aerial', title: 'Aerial Neighborhood View', photoId: '1448630360428-65456885c650' },
  { id: 'photo-aerial-3', sub: 'aerial', title: 'Urban Drone Shot', photoId: '1477959858617-67f85cf4f1df' },
  { id: 'photo-aerial-4', sub: 'aerial', title: 'Coastal City', photoId: '1480714378408-67cf0d13bc1b' },
  { id: 'photo-aerial-5', sub: 'aerial', title: 'Residential Complex Aerial', photoId: '1512917774080-9991f1c4c750' },
  { id: 'photo-aerial-6', sub: 'aerial', title: 'Downtown at Night', photoId: '1519501025264-65ba15a82390' },
  // --- Construction ---
  { id: 'photo-const-1', sub: 'construction', title: 'Construction Site', photoId: '1504307651254-35680f356dfd' },
  { id: 'photo-const-2', sub: 'construction', title: 'Steel Framework', photoId: '1541888946425-d81bb19240f5' },
  { id: 'photo-const-3', sub: 'construction', title: 'Tower Cranes', photoId: '1590666027370-7f70a6b80008' },
  { id: 'photo-const-4', sub: 'construction', title: 'Under Construction Building', photoId: '1503387762-592deb58ef4e' },
  { id: 'photo-const-5', sub: 'construction', title: 'Foundation Work', photoId: '1530803375-f8bfbead7b4f' },
  { id: 'photo-const-6', sub: 'construction', title: 'Blueprint on Site', photoId: '1531834685032-c34bf0d84c77' },
  // --- Luxury / Lifestyle ---
  { id: 'photo-lux-1', sub: 'luxury', title: 'Premium Lobby', photoId: '1600566752355-35792bedcfea' },
  { id: 'photo-lux-2', sub: 'luxury', title: 'Terrace with View', photoId: '1600607687644-c7171b42498f' },
  { id: 'photo-lux-3', sub: 'luxury', title: 'Infinity Pool', photoId: '1506929562872-bb421503ef21' },
  { id: 'photo-lux-4', sub: 'luxury', title: 'Home Theater', photoId: '1593784991095-a205069470b6' },
  { id: 'photo-lux-5', sub: 'luxury', title: 'Designer Staircase', photoId: '1600047509807-ba8f99d2cdde' },
  { id: 'photo-lux-6', sub: 'luxury', title: 'Grand Entrance', photoId: '1600210491369-e753d80a41f3' },
  // --- Landscapes / Green ---
  { id: 'photo-land-1', sub: 'landscapes', title: 'Garden Pathway', photoId: '1558618666-fcd25c85f82e' },
  { id: 'photo-land-2', sub: 'landscapes', title: 'Lake View Property', photoId: '1439066615861-d1af74d74000' },
  { id: 'photo-land-3', sub: 'landscapes', title: 'Mountain Retreat', photoId: '1470252649378-9c29740c9fa8' },
  { id: 'photo-land-4', sub: 'landscapes', title: 'Green Suburb', photoId: '1500382017468-9049fed747ef' },
  { id: 'photo-land-5', sub: 'landscapes', title: 'Waterfront View', photoId: '1507653589690-7c8b29a6addb' },
  { id: 'photo-land-6', sub: 'landscapes', title: 'Park Nearby', photoId: '1519331379826-f10be5486c6f' },
  // --- Details / Textures ---
  { id: 'photo-det-1', sub: 'details', title: 'Wooden Door', photoId: '1558618666-fcd25c85f82e' },
  { id: 'photo-det-2', sub: 'details', title: 'Glass Windows', photoId: '1487958449943-2429e8acb49f' },
  { id: 'photo-det-3', sub: 'details', title: 'Marble Floor', photoId: '1600607687939-ce8a6c25118c' },
  { id: 'photo-det-4', sub: 'details', title: 'Modern Staircase', photoId: '1600047509807-ba8f99d2cdde' },
  { id: 'photo-det-5', sub: 'details', title: 'Balcony Railing', photoId: '1600585154340-be6161a56a0c' },
  { id: 'photo-det-6', sub: 'details', title: 'Backyard Patio', photoId: '1600566752355-35792bedcfea' },
];

const photoElements = photoEntries.map((entry) => ({
  catalogId: entry.id,
  category: 'photos',
  subcategory: entry.sub,
  title: entry.title,
  tags: ['photo', entry.sub, ...entry.title.toLowerCase().split(' ')],
  kind: 'photo',
  preview: {
    type: 'jpg',
    src: `https://images.unsplash.com/photo-${entry.photoId}?auto=format&fit=crop&w=600&q=60`,
  },
  payload: {
    type: 'image',
    src: `https://images.unsplash.com/photo-${entry.photoId}?auto=format&fit=crop&w=1400&q=70`,
    naturalW: 1400,
    naturalH: 933,
  },
}));


const lineArrowItems = [
  {
    catalogId: 'line-solid',
    category: 'lines',
    subcategory: 'basic',
    title: 'Line',
    tags: ['line', 'solid'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="18" y1="50" x2="82" y2="50" />') },
    payload: { type: 'line', dash: 'solid' },
  },
  {
    catalogId: 'line-dashed',
    category: 'lines',
    subcategory: 'basic',
    title: 'Dashed Line',
    tags: ['line', 'dashed'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="18" y1="50" x2="82" y2="50" stroke-dasharray="8 6" />') },
    payload: { type: 'line', dash: 'dashed' },
  },
  {
    catalogId: 'line-dotted',
    category: 'lines',
    subcategory: 'basic',
    title: 'Dotted Line',
    tags: ['line', 'dotted'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="18" y1="50" x2="82" y2="50" stroke-dasharray="2 6" />') },
    payload: { type: 'line', dash: 'dotted' },
  },
  {
    catalogId: 'line-thick',
    category: 'lines',
    subcategory: 'basic',
    title: 'Thick Line',
    tags: ['line', 'thick', 'bold'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"><line x1="18" y1="50" x2="82" y2="50" /></svg>' },
    payload: { type: 'line', dash: 'solid', defaultStrokeWidth: 6 },
  },
  {
    catalogId: 'line-thin',
    category: 'lines',
    subcategory: 'basic',
    title: 'Thin Line',
    tags: ['line', 'thin', 'hairline'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="50" x2="82" y2="50" /></svg>' },
    payload: { type: 'line', dash: 'solid', defaultStrokeWidth: 1 },
  },
  {
    catalogId: 'line-double',
    category: 'lines',
    subcategory: 'decorative',
    title: 'Double Line',
    tags: ['line', 'double', 'rule'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="18" y1="44" x2="82" y2="44" /><line x1="18" y1="56" x2="82" y2="56" />') },
    payload: { type: 'line', dash: 'solid' },
  },
  {
    catalogId: 'line-wave',
    category: 'lines',
    subcategory: 'decorative',
    title: 'Wave Line',
    tags: ['line', 'wave', 'curvy'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M18 50C30 34 42 66 54 50C66 34 82 50 82 50" />') },
    payload: { type: 'line', dash: 'solid' },
  },
  {
    catalogId: 'line-zigzag',
    category: 'lines',
    subcategory: 'decorative',
    title: 'Zigzag Line',
    tags: ['line', 'zigzag'],
    kind: 'line',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M18 50L30 36L42 64L54 36L66 64L82 50" />') },
    payload: { type: 'line', dash: 'solid' },
  },
  {
    catalogId: 'arrow-right',
    category: 'arrows',
    subcategory: 'basic',
    title: 'Arrow Right',
    tags: ['arrow', 'right'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="18" y1="50" x2="74" y2="50" /><path d="M62 36L78 50L62 64" />') },
    payload: { type: 'arrow', arrowHead: 'end' },
  },
  {
    catalogId: 'arrow-left',
    category: 'arrows',
    subcategory: 'basic',
    title: 'Arrow Left',
    tags: ['arrow', 'left'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="26" y1="50" x2="82" y2="50" /><path d="M38 36L22 50L38 64" />') },
    payload: { type: 'arrow', arrowHead: 'start' },
  },
  {
    catalogId: 'arrow-both',
    category: 'arrows',
    subcategory: 'basic',
    title: 'Arrow Both',
    tags: ['arrow', 'both', 'double'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="26" y1="50" x2="74" y2="50" /><path d="M38 36L22 50L38 64" /><path d="M62 36L78 50L62 64" />') },
    payload: { type: 'arrow', arrowHead: 'both' },
  },
  {
    catalogId: 'arrow-dashed',
    category: 'arrows',
    subcategory: 'basic',
    title: 'Dashed Arrow',
    tags: ['arrow', 'dashed'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="18" y1="50" x2="74" y2="50" stroke-dasharray="8 6" /><path d="M62 36L78 50L62 64" />') },
    payload: { type: 'arrow', arrowHead: 'end', dash: 'dashed' },
  },
  {
    catalogId: 'arrow-thick',
    category: 'arrows',
    subcategory: 'basic',
    title: 'Thick Arrow',
    tags: ['arrow', 'thick', 'bold'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: '<svg viewBox="0 0 100 100" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="50" x2="68" y2="50" /><path d="M60 34L78 50L60 66" /></svg>' },
    payload: { type: 'arrow', arrowHead: 'end', defaultStrokeWidth: 5 },
  },
  {
    catalogId: 'arrow-up',
    category: 'arrows',
    subcategory: 'directional',
    title: 'Arrow Up',
    tags: ['arrow', 'up', 'vertical'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="50" y1="82" x2="50" y2="26" /><path d="M36 38L50 22L64 38" />') },
    payload: { type: 'arrow', arrowHead: 'end', width: 6, height: 320 },
  },
  {
    catalogId: 'arrow-down',
    category: 'arrows',
    subcategory: 'directional',
    title: 'Arrow Down',
    tags: ['arrow', 'down', 'vertical'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<line x1="50" y1="18" x2="50" y2="74" /><path d="M36 62L50 78L64 62" />') },
    payload: { type: 'arrow', arrowHead: 'end', width: 6, height: 320 },
  },
  {
    catalogId: 'arrow-curved',
    category: 'arrows',
    subcategory: 'directional',
    title: 'Curved Arrow',
    tags: ['arrow', 'curved', 'bend'],
    kind: 'arrow',
    preview: { type: 'svg', inlineSvg: outlineSvg('<path d="M22 60C22 30 78 30 78 60" /><path d="M66 52L78 60L70 72" />') },
    payload: { type: 'arrow', arrowHead: 'end' },
  },
];

const frameItems = FRAMES_CATALOG.map((frame) => ({
  catalogId: frame.frameId,
  category: 'frames',
  subcategory: frame.subcategory || 'basic',
  title: frame.title,
  tags: ['frame', ...(frame.tags || [])],
  kind: 'frame',
  preview: { type: 'svg', inlineSvg: frame.previewSvg },
  payload: {
    type: 'frame',
    frameId: frame.frameId,
    shapeType: frame.shapeType,
    viewBox: frame.viewBox,
    pathD: frame.pathD,
    cornerRadius: frame.cornerRadius,
    width: frame.defaultSize?.width,
    height: frame.defaultSize?.height,
  },
}));

const tableItems = [
  {
    catalogId: 'table-2x2',
    category: 'tables',
    subcategory: 'basic',
    title: '2x2 Table',
    tags: ['table', '2x2'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="20" y="28" width="60" height="44" rx="4" /><path d="M50 28V72M20 50H80" />') },
    payload: { type: 'table', rows: 2, cols: 2 },
  },
  {
    catalogId: 'table-3x3',
    category: 'tables',
    subcategory: 'basic',
    title: '3x3 Table',
    tags: ['table', '3x3'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="26" width="64" height="48" rx="4" /><path d="M40 26V74M60 26V74M18 42H82M18 58H82" />') },
    payload: { type: 'table', rows: 3, cols: 3 },
  },
  {
    catalogId: 'table-pricing',
    category: 'tables',
    subcategory: 'pricing',
    title: 'Pricing Table',
    tags: ['table', 'pricing', 'comparison'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="16" y="30" width="68" height="40" rx="4" /><path d="M38 30V70M62 30V70M16 50H84" />') },
    payload: { type: 'table', rows: 3, cols: 3, headerRow: true },
  },
  {
    catalogId: 'table-4x4',
    category: 'tables',
    subcategory: 'basic',
    title: '4x4 Table',
    tags: ['table', '4x4', 'large'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="16" y="24" width="68" height="52" rx="4" /><path d="M34 24V76M52 24V76M70 24V76M16 38H84M16 50H84M16 62H84" />') },
    payload: { type: 'table', rows: 4, cols: 4 },
  },
  {
    catalogId: 'table-5x2',
    category: 'tables',
    subcategory: 'basic',
    title: '5x2 Table',
    tags: ['table', '5x2', 'list'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="56" rx="4" /><path d="M50 22V78M18 33H82M18 44H82M18 55H82M18 66H82" />') },
    payload: { type: 'table', rows: 5, cols: 2 },
  },
  {
    catalogId: 'table-specs',
    category: 'tables',
    subcategory: 'real-estate',
    title: 'Property Specs',
    tags: ['table', 'specs', 'property', 'details'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="64" height="52" rx="4" /><path d="M44 24V76M18 38H82M18 50H82M18 62H82" />') },
    payload: { type: 'table', rows: 4, cols: 2, headerRow: true },
  },
  {
    catalogId: 'table-amenity',
    category: 'tables',
    subcategory: 'real-estate',
    title: 'Amenity Checklist',
    tags: ['table', 'amenity', 'checklist'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="56" rx="4" /><path d="M44 22V78M18 36H82M18 50H82M18 64H82" />') },
    payload: { type: 'table', rows: 4, cols: 2 },
  },
  {
    catalogId: 'table-emi',
    category: 'tables',
    subcategory: 'real-estate',
    title: 'EMI Breakdown',
    tags: ['table', 'emi', 'finance', 'loan'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="16" y="24" width="68" height="52" rx="4" /><path d="M38 24V76M60 24V76M16 38H84M16 50H84M16 62H84" />') },
    payload: { type: 'table', rows: 4, cols: 3, headerRow: true },
  },
  {
    catalogId: 'table-compare',
    category: 'tables',
    subcategory: 'real-estate',
    title: 'Comparison Table',
    tags: ['table', 'comparison', 'versus'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="14" y="26" width="72" height="48" rx="4" /><path d="M38 26V74M62 26V74M14 42H86M14 58H86" />') },
    payload: { type: 'table', rows: 3, cols: 3, headerRow: true },
  },
  {
    catalogId: 'table-timeline',
    category: 'tables',
    subcategory: 'real-estate',
    title: 'Timeline Table',
    tags: ['table', 'timeline', 'milestone'],
    kind: 'table',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="64" height="52" rx="4" /><path d="M36 24V76M18 38H82M18 50H82M18 62H82" />') },
    payload: { type: 'table', rows: 4, cols: 2 },
  },
];

const chartItems = [
  {
    catalogId: 'chart-bar',
    category: 'charts',
    subcategory: 'basic',
    title: 'Bar Chart',
    tags: ['chart', 'bar'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: iconSvg('<path d="M20 78H80" /><rect x="26" y="50" width="10" height="28" fill="currentColor" stroke="none" /><rect x="44" y="38" width="10" height="40" fill="currentColor" stroke="none" /><rect x="62" y="28" width="10" height="50" fill="currentColor" stroke="none" />') },
    payload: { type: 'chart', chartType: 'bar' },
  },
  {
    catalogId: 'chart-line',
    category: 'charts',
    subcategory: 'basic',
    title: 'Line Chart',
    tags: ['chart', 'line'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: iconSvg('<path d="M20 78H80" /><path d="M24 62L40 48L56 54L74 34" />') },
    payload: { type: 'chart', chartType: 'line' },
  },
  {
    catalogId: 'chart-pie',
    category: 'charts',
    subcategory: 'basic',
    title: 'Pie Chart',
    tags: ['chart', 'pie'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: solidSvg('<path d="M50 20A30 30 0 1 1 26 30L50 50Z" /><path d="M50 20V50H80A30 30 0 0 0 50 20Z" />') },
    payload: { type: 'chart', chartType: 'pie' },
  },
  {
    catalogId: 'chart-donut',
    category: 'charts',
    subcategory: 'basic',
    title: 'Donut Chart',
    tags: ['chart', 'donut'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: gradientPreview('<circle cx="50" cy="50" r="26" stroke="currentColor" stroke-width="10" fill="none" /><path d="M50 24A26 26 0 0 1 74 50" stroke="#c9a962" stroke-width="10" />') },
    payload: { type: 'chart', chartType: 'donut' },
  },
  {
    catalogId: 'chart-area',
    category: 'charts',
    subcategory: 'basic',
    title: 'Area Chart',
    tags: ['chart', 'area', 'trend'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: iconSvg('<path d="M20 78H80" /><path d="M24 62L40 48L56 54L74 34V78H24Z" fill="currentColor" fill-opacity="0.2" stroke="none" /><path d="M24 62L40 48L56 54L74 34" />') },
    payload: { type: 'chart', chartType: 'line' },
  },
  {
    catalogId: 'chart-hbar',
    category: 'charts',
    subcategory: 'basic',
    title: 'Horizontal Bar',
    tags: ['chart', 'horizontal', 'bar'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: iconSvg('<path d="M20 20V80" /><rect x="20" y="26" width="40" height="10" fill="currentColor" stroke="none" rx="2" /><rect x="20" y="44" width="56" height="10" fill="currentColor" stroke="none" rx="2" /><rect x="20" y="62" width="32" height="10" fill="currentColor" stroke="none" rx="2" />') },
    payload: { type: 'chart', chartType: 'bar' },
  },
  {
    catalogId: 'chart-stacked',
    category: 'charts',
    subcategory: 'basic',
    title: 'Stacked Bar',
    tags: ['chart', 'stacked', 'bar'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: iconSvg('<path d="M20 78H80" /><rect x="28" y="48" width="12" height="30" fill="currentColor" stroke="none" rx="2" /><rect x="28" y="32" width="12" height="16" fill="currentColor" fill-opacity="0.4" stroke="none" rx="2" /><rect x="48" y="38" width="12" height="40" fill="currentColor" stroke="none" rx="2" /><rect x="48" y="24" width="12" height="14" fill="currentColor" fill-opacity="0.4" stroke="none" rx="2" />') },
    payload: { type: 'chart', chartType: 'bar' },
  },
  {
    catalogId: 'chart-radar',
    category: 'charts',
    subcategory: 'advanced',
    title: 'Radar Chart',
    tags: ['chart', 'radar', 'spider'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: iconSvg('<path d="M50 20L80 40L70 74L30 74L20 40Z" /><path d="M50 34L66 44L62 62L38 62L34 44Z" fill="currentColor" fill-opacity="0.2" stroke="currentColor" />') },
    payload: { type: 'chart', chartType: 'line' },
  },
  {
    catalogId: 'chart-funnel',
    category: 'charts',
    subcategory: 'advanced',
    title: 'Funnel Chart',
    tags: ['chart', 'funnel', 'conversion'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: solidSvg('<rect x="18" y="22" width="64" height="12" rx="3" fill-opacity="1" /><rect x="26" y="38" width="48" height="12" rx="3" fill-opacity="0.7" /><rect x="34" y="54" width="32" height="12" rx="3" fill-opacity="0.4" /><rect x="40" y="70" width="20" height="12" rx="3" fill-opacity="0.2" />') },
    payload: { type: 'chart', chartType: 'bar' },
  },
  {
    catalogId: 'chart-gauge',
    category: 'charts',
    subcategory: 'advanced',
    title: 'Gauge Chart',
    tags: ['chart', 'gauge', 'meter'],
    kind: 'chart',
    preview: { type: 'svg', inlineSvg: gradientPreview('<path d="M22 66A30 30 0 0178 66" stroke="currentColor" stroke-width="10" fill="none" stroke-linecap="round" /><path d="M22 66A30 30 0 0162 28" stroke="#c9a962" stroke-width="10" fill="none" stroke-linecap="round" />') },
    payload: { type: 'chart', chartType: 'donut' },
  },
];

const gridItems = [
  {
    catalogId: 'grid-2x2',
    category: 'grids',
    subcategory: 'basic',
    title: '2x2 Grid',
    tags: ['grid', '2x2'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="20" y="24" width="60" height="52" rx="6" /><path d="M50 24V76M20 50H80" />') },
    payload: { type: 'grid', layout: '2x2' },
  },
  {
    catalogId: 'grid-3x1',
    category: 'grids',
    subcategory: 'basic',
    title: '3x1 Grid',
    tags: ['grid', 'strip'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="36" width="64" height="28" rx="6" /><path d="M38 36V64M62 36V64" />') },
    payload: { type: 'grid', layout: '3x1' },
  },
  {
    catalogId: 'grid-1-2',
    category: 'grids',
    subcategory: 'collage',
    title: '1+2 Collage',
    tags: ['grid', 'collage'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="30" height="52" rx="6" /><rect x="52" y="24" width="30" height="24" rx="6" /><rect x="52" y="52" width="30" height="24" rx="6" />') },
    payload: { type: 'grid', layout: '1+2' },
  },
  {
    catalogId: 'grid-3x3',
    category: 'grids',
    subcategory: 'basic',
    title: '3x3 Grid',
    tags: ['grid', '3x3'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="64" height="52" rx="4" /><path d="M40 24V76M60 24V76M18 42H82M18 58H82" />') },
    payload: { type: 'grid', layout: '3x3' },
  },
  {
    catalogId: 'grid-2x1',
    category: 'grids',
    subcategory: 'basic',
    title: '2x1 Grid',
    tags: ['grid', '2x1', 'split'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="28" width="28" height="44" rx="6" /><rect x="54" y="28" width="28" height="44" rx="6" />') },
    payload: { type: 'grid', layout: '2x2' },
  },
  {
    catalogId: 'grid-1x4',
    category: 'grids',
    subcategory: 'basic',
    title: '1x4 Strip',
    tags: ['grid', '1x4', 'strip'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="38" width="64" height="24" rx="4" /><path d="M34 38V62M50 38V62M66 38V62" />') },
    payload: { type: 'grid', layout: '3x1' },
  },
  {
    catalogId: 'grid-2x3',
    category: 'grids',
    subcategory: 'basic',
    title: '2x3 Grid',
    tags: ['grid', '2x3'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="56" rx="4" /><path d="M40 22V78M60 22V78M18 50H82" />') },
    payload: { type: 'grid', layout: '3x3' },
  },
  {
    catalogId: 'grid-hero-3',
    category: 'grids',
    subcategory: 'collage',
    title: 'Hero + 3',
    tags: ['grid', 'hero', 'collage'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="28" rx="6" /><rect x="18" y="54" width="18" height="22" rx="4" /><rect x="41" y="54" width="18" height="22" rx="4" /><rect x="64" y="54" width="18" height="22" rx="4" />') },
    payload: { type: 'grid', layout: '3x3' },
  },
  {
    catalogId: 'grid-l-shape',
    category: 'grids',
    subcategory: 'collage',
    title: 'L-Shape',
    tags: ['grid', 'l-shape', 'collage'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="40" height="56" rx="6" /><rect x="62" y="22" width="20" height="26" rx="4" /><rect x="62" y="52" width="20" height="26" rx="4" />') },
    payload: { type: 'grid', layout: '1+2' },
  },
  {
    catalogId: 'grid-t-shape',
    category: 'grids',
    subcategory: 'collage',
    title: 'T-Shape',
    tags: ['grid', 't-shape', 'collage'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="28" rx="6" /><rect x="18" y="54" width="30" height="22" rx="4" /><rect x="52" y="54" width="30" height="22" rx="4" />') },
    payload: { type: 'grid', layout: '2x2' },
  },
  {
    catalogId: 'grid-mosaic',
    category: 'grids',
    subcategory: 'collage',
    title: 'Mosaic',
    tags: ['grid', 'mosaic', 'collage'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="30" height="26" rx="4" /><rect x="52" y="22" width="30" height="56" rx="4" /><rect x="18" y="52" width="30" height="26" rx="4" />') },
    payload: { type: 'grid', layout: '1+2' },
  },
  {
    catalogId: 'grid-panoramic',
    category: 'grids',
    subcategory: 'basic',
    title: 'Panoramic',
    tags: ['grid', 'panoramic', 'wide'],
    kind: 'grid',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="34" width="64" height="32" rx="6" /><path d="M38 34V66M62 34V66" />') },
    payload: { type: 'grid', layout: '3x1' },
  },
];

const formItems = [
  {
    catalogId: 'form-cta',
    category: 'forms',
    subcategory: 'cta',
    title: 'CTA Button',
    tags: ['button', 'cta'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<rect x="16" y="36" width="68" height="28" rx="14" />') },
    payload: {
      type: 'groupPreset',
      title: 'CTA Button',
      width: 360,
      height: 120,
      elements: [
        { type: 'shape', x: 0.05, y: 0.32, w: 0.9, h: 0.36, radius: 40, fill: '#111111', stroke: '#111111', strokeWidth: 0 },
        { type: 'text', x: 0.18, y: 0.38, w: 0.64, h: 0.2, text: 'Enquire Now', fontSize: 28, fontWeight: 600, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-price-tag',
    category: 'forms',
    subcategory: 'cta',
    title: 'Price Tag',
    tags: ['price', 'tag'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<rect x="18" y="36" width="64" height="28" rx="8" />') },
    payload: {
      type: 'groupPreset',
      title: 'Price Tag',
      width: 320,
      height: 120,
      elements: [
        { type: 'shape', x: 0.08, y: 0.3, w: 0.84, h: 0.4, radius: 12, fill: '#c9a962', stroke: '#c9a962', strokeWidth: 0 },
        { type: 'text', x: 0.18, y: 0.38, w: 0.64, h: 0.2, text: '₹ 1.2 Cr', fontSize: 26, fontWeight: 600, color: '#111111', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-verified',
    category: 'forms',
    subcategory: 'badges',
    title: 'Verified Badge',
    tags: ['verified', 'badge'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<circle cx="50" cy="50" r="24" />') },
    payload: {
      type: 'groupPreset',
      title: 'Verified Badge',
      width: 200,
      height: 200,
      elements: [
        { type: 'shape', shapeType: 'circle', x: 0.1, y: 0.1, w: 0.8, h: 0.8, radius: 100, fill: '#111111', stroke: '#111111', strokeWidth: 0 },
        { type: 'text', x: 0.28, y: 0.42, w: 0.44, h: 0.2, text: '✓', fontSize: 54, fontWeight: 600, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-contact',
    category: 'forms',
    subcategory: 'cards',
    title: 'Contact Card',
    tags: ['contact', 'card'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="26" width="64" height="48" rx="8" /><path d="M28 42H72M28 54H60" />') },
    payload: {
      type: 'groupPreset',
      title: 'Contact Card',
      width: 420,
      height: 220,
      elements: [
        { type: 'shape', x: 0.05, y: 0.1, w: 0.9, h: 0.8, radius: 16, fill: '#F8F4EC', stroke: '#C9A962', strokeWidth: 2 },
        { type: 'text', x: 0.12, y: 0.22, w: 0.7, h: 0.2, text: 'Contact Agent', fontSize: 22, fontWeight: 600, color: '#111111', align: 'left' },
        { type: 'text', x: 0.12, y: 0.45, w: 0.7, h: 0.2, text: '+91 98765 43210', fontSize: 18, fontWeight: 500, color: '#111111', align: 'left' },
        { type: 'text', x: 0.12, y: 0.62, w: 0.7, h: 0.2, text: 'agent@domain.com', fontSize: 16, fontWeight: 400, color: '#111111', align: 'left' },
      ],
    },
  },
  {
    catalogId: 'form-feature-list',
    category: 'forms',
    subcategory: 'cards',
    title: 'Feature List Card',
    tags: ['features', 'list'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="26" width="64" height="48" rx="8" /><path d="M30 42H72M30 52H72M30 62H66" />') },
    payload: {
      type: 'groupPreset',
      title: 'Feature List',
      width: 420,
      height: 240,
      elements: [
        { type: 'shape', x: 0.05, y: 0.1, w: 0.9, h: 0.8, radius: 16, fill: '#FFFFFF', stroke: '#C9A962', strokeWidth: 2 },
        { type: 'text', x: 0.12, y: 0.22, w: 0.7, h: 0.2, text: 'Top Features', fontSize: 20, fontWeight: 600, color: '#111111', align: 'left' },
        { type: 'text', x: 0.12, y: 0.42, w: 0.7, h: 0.2, text: '• Prime Location', fontSize: 16, fontWeight: 400, color: '#111111', align: 'left' },
        { type: 'text', x: 0.12, y: 0.57, w: 0.7, h: 0.2, text: '• Ready to Move', fontSize: 16, fontWeight: 400, color: '#111111', align: 'left' },
        { type: 'text', x: 0.12, y: 0.72, w: 0.7, h: 0.2, text: '• Bank Approved', fontSize: 16, fontWeight: 400, color: '#111111', align: 'left' },
      ],
    },
  },
  {
    catalogId: 'form-listing',
    category: 'forms',
    subcategory: 'cards',
    title: 'Listing Card',
    tags: ['listing', 'property', 'card'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="20" width="64" height="60" rx="8" /><path d="M18 44H82" /><path d="M28 54H72M28 64H60" />') },
    payload: {
      type: 'groupPreset',
      title: 'Listing Card',
      width: 420,
      height: 300,
      elements: [
        { type: 'shape', x: 0.05, y: 0.05, w: 0.9, h: 0.9, radius: 16, fill: '#FFFFFF', stroke: '#C9A962', strokeWidth: 2 },
        { type: 'text', x: 0.1, y: 0.1, w: 0.8, h: 0.1, text: '2 BHK Apartment', fontSize: 22, fontWeight: 600, color: '#111111', align: 'left' },
        { type: 'text', x: 0.1, y: 0.28, w: 0.8, h: 0.08, text: 'Whitefield, Bangalore', fontSize: 16, fontWeight: 400, color: '#666666', align: 'left' },
        { type: 'text', x: 0.1, y: 0.45, w: 0.4, h: 0.08, text: '₹ 85 Lakhs', fontSize: 24, fontWeight: 700, color: '#C9A962', align: 'left' },
        { type: 'text', x: 0.1, y: 0.62, w: 0.8, h: 0.08, text: '1,250 sqft • 2 Bed • 2 Bath', fontSize: 14, fontWeight: 400, color: '#444444', align: 'left' },
        { type: 'shape', x: 0.1, y: 0.78, w: 0.35, h: 0.12, radius: 24, fill: '#111111', stroke: '#111111', strokeWidth: 0 },
        { type: 'text', x: 0.14, y: 0.8, w: 0.27, h: 0.08, text: 'View Details', fontSize: 14, fontWeight: 600, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-for-sale',
    category: 'forms',
    subcategory: 'badges',
    title: 'For Sale Banner',
    tags: ['sale', 'banner', 'sign'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<rect x="14" y="34" width="72" height="32" rx="6" />') },
    payload: {
      type: 'groupPreset',
      title: 'For Sale',
      width: 320,
      height: 100,
      elements: [
        { type: 'shape', x: 0.05, y: 0.15, w: 0.9, h: 0.7, radius: 10, fill: '#C9A962', stroke: '#C9A962', strokeWidth: 0 },
        { type: 'text', x: 0.12, y: 0.28, w: 0.76, h: 0.4, text: 'FOR SALE', fontSize: 28, fontWeight: 700, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-for-rent',
    category: 'forms',
    subcategory: 'badges',
    title: 'For Rent Banner',
    tags: ['rent', 'banner', 'sign'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<rect x="14" y="34" width="72" height="32" rx="6" fill-opacity="0.8" />') },
    payload: {
      type: 'groupPreset',
      title: 'For Rent',
      width: 320,
      height: 100,
      elements: [
        { type: 'shape', x: 0.05, y: 0.15, w: 0.9, h: 0.7, radius: 10, fill: '#2D5F4A', stroke: '#2D5F4A', strokeWidth: 0 },
        { type: 'text', x: 0.12, y: 0.28, w: 0.76, h: 0.4, text: 'FOR RENT', fontSize: 28, fontWeight: 700, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-sold',
    category: 'forms',
    subcategory: 'badges',
    title: 'Sold Ribbon',
    tags: ['sold', 'ribbon', 'badge'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<path d="M18 36H82L74 50L82 64H18L26 50Z" />') },
    payload: {
      type: 'groupPreset',
      title: 'Sold Ribbon',
      width: 300,
      height: 100,
      elements: [
        { type: 'shape', x: 0.05, y: 0.2, w: 0.9, h: 0.6, radius: 4, fill: '#D32F2F', stroke: '#D32F2F', strokeWidth: 0 },
        { type: 'text', x: 0.15, y: 0.3, w: 0.7, h: 0.35, text: 'SOLD', fontSize: 30, fontWeight: 700, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-new-launch',
    category: 'forms',
    subcategory: 'badges',
    title: 'New Launch Badge',
    tags: ['new', 'launch', 'badge'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: solidSvg('<circle cx="50" cy="50" r="28" />') },
    payload: {
      type: 'groupPreset',
      title: 'New Launch',
      width: 200,
      height: 200,
      elements: [
        { type: 'shape', shapeType: 'circle', x: 0.1, y: 0.1, w: 0.8, h: 0.8, radius: 100, fill: '#C9A962', stroke: '#C9A962', strokeWidth: 0 },
        { type: 'text', x: 0.2, y: 0.32, w: 0.6, h: 0.14, text: 'NEW', fontSize: 22, fontWeight: 700, color: '#FFFFFF', align: 'center' },
        { type: 'text', x: 0.15, y: 0.48, w: 0.7, h: 0.14, text: 'LAUNCH', fontSize: 20, fontWeight: 600, color: '#FFFFFF', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-open-house',
    category: 'forms',
    subcategory: 'cards',
    title: 'Open House Card',
    tags: ['open', 'house', 'event'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="56" rx="8" /><path d="M28 38H72M28 50H60M28 62H50" />') },
    payload: {
      type: 'groupPreset',
      title: 'Open House',
      width: 400,
      height: 260,
      elements: [
        { type: 'shape', x: 0.05, y: 0.05, w: 0.9, h: 0.9, radius: 16, fill: '#F8F4EC', stroke: '#C9A962', strokeWidth: 2 },
        { type: 'text', x: 0.1, y: 0.12, w: 0.8, h: 0.12, text: 'OPEN HOUSE', fontSize: 24, fontWeight: 700, color: '#C9A962', align: 'center' },
        { type: 'text', x: 0.1, y: 0.34, w: 0.8, h: 0.1, text: 'Saturday, 15th March', fontSize: 18, fontWeight: 500, color: '#111111', align: 'center' },
        { type: 'text', x: 0.1, y: 0.52, w: 0.8, h: 0.1, text: '10:00 AM - 4:00 PM', fontSize: 16, fontWeight: 400, color: '#666666', align: 'center' },
        { type: 'text', x: 0.1, y: 0.72, w: 0.8, h: 0.1, text: 'Prestige Lakeside, Whitefield', fontSize: 14, fontWeight: 400, color: '#444444', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-testimonial',
    category: 'forms',
    subcategory: 'cards',
    title: 'Testimonial Card',
    tags: ['testimonial', 'review', 'quote'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="56" rx="8" /><path d="M28 38H42V50H28Z" /><path d="M48 58H72" />') },
    payload: {
      type: 'groupPreset',
      title: 'Testimonial',
      width: 420,
      height: 240,
      elements: [
        { type: 'shape', x: 0.05, y: 0.05, w: 0.9, h: 0.9, radius: 16, fill: '#FFFFFF', stroke: '#E0D9CB', strokeWidth: 1 },
        { type: 'text', x: 0.1, y: 0.28, w: 0.8, h: 0.3, text: 'Exceptional service! Found our dream home in just 2 weeks.', fontSize: 16, fontWeight: 400, color: '#333333', align: 'left' },
        { type: 'text', x: 0.1, y: 0.7, w: 0.8, h: 0.1, text: '— Priya & Rahul S.', fontSize: 14, fontWeight: 600, color: '#111111', align: 'left' },
      ],
    },
  },
  {
    catalogId: 'form-agent',
    category: 'forms',
    subcategory: 'cards',
    title: 'Agent Profile Card',
    tags: ['agent', 'profile', 'realtor'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="22" width="64" height="56" rx="8" /><circle cx="50" cy="40" r="10" /><path d="M32 62H68" />') },
    payload: {
      type: 'groupPreset',
      title: 'Agent Card',
      width: 360,
      height: 280,
      elements: [
        { type: 'shape', x: 0.05, y: 0.05, w: 0.9, h: 0.9, radius: 16, fill: '#111111', stroke: '#111111', strokeWidth: 0 },
        { type: 'text', x: 0.1, y: 0.18, w: 0.8, h: 0.1, text: 'Amit Sharma', fontSize: 22, fontWeight: 700, color: '#FFFFFF', align: 'center' },
        { type: 'text', x: 0.1, y: 0.34, w: 0.8, h: 0.08, text: 'Senior Property Advisor', fontSize: 14, fontWeight: 400, color: '#C9A962', align: 'center' },
        { type: 'text', x: 0.1, y: 0.52, w: 0.8, h: 0.08, text: '+91 98765 43210', fontSize: 14, fontWeight: 500, color: '#FFFFFF', align: 'center' },
        { type: 'text', x: 0.1, y: 0.66, w: 0.8, h: 0.08, text: 'amit@realestate.com', fontSize: 13, fontWeight: 400, color: '#AAAAAA', align: 'center' },
        { type: 'shape', x: 0.2, y: 0.8, w: 0.6, h: 0.1, radius: 20, fill: '#C9A962', stroke: '#C9A962', strokeWidth: 0 },
        { type: 'text', x: 0.25, y: 0.82, w: 0.5, h: 0.06, text: 'Book a Visit', fontSize: 14, fontWeight: 600, color: '#111111', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-specs',
    category: 'forms',
    subcategory: 'cards',
    title: 'Property Specs Card',
    tags: ['specs', 'details', 'highlights'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="18" y="24" width="64" height="52" rx="8" /><path d="M50 24V76M18 50H82" />') },
    payload: {
      type: 'groupPreset',
      title: 'Specs Card',
      width: 420,
      height: 200,
      elements: [
        { type: 'shape', x: 0.05, y: 0.1, w: 0.9, h: 0.8, radius: 14, fill: '#F8F4EC', stroke: '#E0D9CB', strokeWidth: 1 },
        { type: 'text', x: 0.1, y: 0.18, w: 0.35, h: 0.12, text: '3 Beds', fontSize: 18, fontWeight: 600, color: '#111111', align: 'center' },
        { type: 'text', x: 0.55, y: 0.18, w: 0.35, h: 0.12, text: '2 Baths', fontSize: 18, fontWeight: 600, color: '#111111', align: 'center' },
        { type: 'text', x: 0.1, y: 0.55, w: 0.35, h: 0.12, text: '1,850 sqft', fontSize: 18, fontWeight: 600, color: '#111111', align: 'center' },
        { type: 'text', x: 0.55, y: 0.55, w: 0.35, h: 0.12, text: '2 Parking', fontSize: 18, fontWeight: 600, color: '#111111', align: 'center' },
      ],
    },
  },
  {
    catalogId: 'form-highlights',
    category: 'forms',
    subcategory: 'badges',
    title: 'Key Highlights',
    tags: ['highlights', 'banner', 'key'],
    kind: 'form',
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="16" y="30" width="68" height="40" rx="8" /><path d="M28 46H72M28 58H60" />') },
    payload: {
      type: 'groupPreset',
      title: 'Key Highlights',
      width: 460,
      height: 160,
      elements: [
        { type: 'shape', x: 0.03, y: 0.1, w: 0.94, h: 0.8, radius: 14, fill: '#FFFFFF', stroke: '#C9A962', strokeWidth: 2 },
        { type: 'text', x: 0.06, y: 0.18, w: 0.88, h: 0.18, text: 'KEY HIGHLIGHTS', fontSize: 18, fontWeight: 700, color: '#C9A962', align: 'left' },
        { type: 'text', x: 0.06, y: 0.42, w: 0.88, h: 0.12, text: 'RERA Approved • Vastu Compliant', fontSize: 14, fontWeight: 400, color: '#333333', align: 'left' },
        { type: 'text', x: 0.06, y: 0.62, w: 0.88, h: 0.12, text: 'Ready to Move • Premium Location', fontSize: 14, fontWeight: 400, color: '#333333', align: 'left' },
      ],
    },
  },
];

const comingSoonItems = (category, count = 8) =>
  Array.from({ length: count }).map((_, index) => ({
    catalogId: `${category}-placeholder-${index + 1}`,
    category,
    subcategory: 'placeholder',
    title: `${category.charAt(0).toUpperCase() + category.slice(1)} ${index + 1}`,
    tags: [category, 'coming-soon'],
    kind: category,
    preview: { type: 'svg', inlineSvg: outlineSvg('<rect x="24" y="24" width="52" height="52" rx="10" />') },
    payload: { type: 'comingSoon' },
    disabled: true,
  }));

const gradientSwatches = [
  gradientPreview('<defs><linearGradient id="g1" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#c9a962" /><stop offset="100%" stop-color="#111111" /></linearGradient></defs><rect x="20" y="20" width="60" height="60" rx="12" fill="url(#g1)" />'),
  gradientPreview('<defs><linearGradient id="g2" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#7ed0ff" /><stop offset="100%" stop-color="#f6d365" /></linearGradient></defs><rect x="20" y="20" width="60" height="60" rx="12" fill="url(#g2)" />'),
];

const mockupItems = comingSoonItems('mockups', 10);
const videoItems = comingSoonItems('videos', 10);
const audioItems = comingSoonItems('audio', 10);
const animationItems = comingSoonItems('animations', 10);
const sheetItems = comingSoonItems('sheets', 6);
const threeDItems = comingSoonItems('3d', 10);

export const ELEMENT_ITEMS = [
  ...shapeItems,
  ...graphicElements,
  ...photoElements,
  ...lineArrowItems,
  ...frameItems,
  ...tableItems,
  ...chartItems,
  ...gridItems,
  ...formItems,
  ...videoItems,
  ...threeDItems,
  ...animationItems,
  ...audioItems,
  ...sheetItems,
  ...mockupItems,
  {
    catalogId: 'graphics-gradient-sample',
    category: 'graphics',
    subcategory: 'decor',
    title: 'Gradient Badge',
    tags: ['graphic', 'gradient'],
    kind: 'graphic',
    preview: { type: 'svg', inlineSvg: gradientSwatches[0] },
    payload: { type: 'graphic', svg: gradientSwatches[0] },
  },
  {
    catalogId: 'graphics-gradient-sample-2',
    category: 'graphics',
    subcategory: 'decor',
    title: 'Gradient Tile',
    tags: ['graphic', 'gradient'],
    kind: 'graphic',
    preview: { type: 'svg', inlineSvg: gradientSwatches[1] },
    payload: { type: 'graphic', svg: gradientSwatches[1] },
  },
];
